import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

const COLOR_BLIND_CLASSES = {
  protanopia: CLASSES.protanopia,
  deuteranopia: CLASSES.deuteranopia,
  tritanopia: CLASSES.tritanopia,
};

export function applyColorBlind(key, enabled) {
  const cls = COLOR_BLIND_CLASSES[key];
  if (!cls) return;

  if (enabled) {
    Object.values(COLOR_BLIND_CLASSES).forEach((c) => {
      if (c !== cls) document.documentElement.classList.remove(c);
    });
  }

  toggleHtmlClass(cls, enabled);
}

export function removeAllColorBlind() {
  Object.values(COLOR_BLIND_CLASSES).forEach((c) => {
    document.documentElement.classList.remove(c);
  });
}
